import styled from 'styled-components';

export const FollowComponentWrapper = styled.div`
    font-family: 'Alliance No.1';
    font-style: normal;
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    justify-content: space-between;
    padding: 5px 15px 5px 5px;
    gap: 16px;

    background: rgba(255, 255, 255, 0.05);
    border-radius: 500px;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        padding: 10px 15px 10px 20px;
        flex-direction: row;
    }
`;

export const FollowerCountWrapper = styled.div`
    cursor: pointer;
    font-family: 'Alliance No.1';
    font-weight: 600;
    font-size: 0.75;
    line-height: 1.25;
    display: flex;
    align-items: center;
    letter-spacing: -0.03em;

    color: rgba(255, 255, 255, 0.5);

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        font-size: 1rem;
        line-height: 1.2;
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        &:hover {
            text-decoration: underline;
        }
    }
`;

export const FollowerCount = styled.span`
    color: ${({ theme }) => theme.colors.white};
    margin-left: 5px;
`;

export const FollowerGains = styled.span`
    -webkit-font-smoothing: antialiased;

    color: rgba(98, 250, 113, 1);

    border-radius: 12px;

    font-family: 'Alliance No.1';

    font-size: 10px;
    font-weight: 600;
    line-height: 13px;
    letter-spacing: -0.02em;
    text-align: left;

    text-align: right;
`;

export const FollowerInfoWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: baseline;
`;
